import { useContext, useState } from 'react';
import CloseCircle from '../../../assets/icons/CloseCircle';
import ShareIcon from '../../../assets/icons/ShareIcon';
import Button from '../../../ui/Button';
import Modal from '../../../ui/Modal';
import MintModal from '../unclaimed/MintModal';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { AuthContext } from '../../../contexts/AuthContext';
import Loader from '../../../ui/Loader';
import { getIcLink } from '../../../helpers/getIcLink';
import MetamaskConnection from '../../walletConnection/MetamaskConnection';
import PhantomConnection from '../../walletConnection/PhantomConnection';
import ButtonNew from '../../../ui/ButtonNew';

function ClaimedCertificateBack({ certificateId, image, ic, setAskToConnectWallet }) {
    const { mintYourIc, claimYourIc, minting, claiming } = useContext(ProfileContext);
    const { state } = useContext(AuthContext);
    const { user } = state;
    const userProfile = user[0];
    return (
        <>


            <div className=" px-[100.7px]">

                <ButtonNew
                    onClick={() => {
                        window.open(image, '_blank');
                    }}
                    variant="blue"
                    className=" py-2 px-6 text-xs flex  items-center justify-center gap-2  font-medium"
                    size='xs'
                    fixedMinWidth={true}

                >
                    <span className='flex items-center gap-2'>
                        <span >
                            {' '}
                            Share{' '}
                        </span>{' '}
                        <ShareIcon fillColor="#fff" />

                    </span>

                </ButtonNew>

                <p className="text-xs  text-[#fff] font-semibold  text-center my-3 ">OR</p>

                <ButtonNew
                    onClick={() => {
                        if (ic?.blockchain.name !== 'solana' && !userProfile?.evmAddress) {
                            setAskToConnectWallet('metamask');
                            return;
                        } else if (ic?.blockchain.name === 'solana' && !userProfile?.walletAddress) {
                            setAskToConnectWallet('phantom');
                            return;
                        }
                        mintYourIc(certificateId, userProfile?.walletAddress);
                    }}
                    className="text-xs font-medium"
                    size="xs"
                    fixedMinWidth={true}
                >
                    {minting ? <Loader w="w-4" h="h-4" /> : ' Mint as NFT'}
                </ButtonNew>
            </div>
            <div className="flex items-center justify-center mt-1">
                <div className="flex items-center  gap-1  ">
                    <img className="w-5 h-5 rounded-full" src={ic?.blockchain.image} alt={ic?.blockchain.name} />
                    <p className="text-xs text-[#fff] flex-1">
                        This Ic can be minted on <span className="capitalize">{ic?.blockchain?.name}</span>{' '}
                        blockchain
                    </p>
                </div>

            </div>
            <div>
                <Modal>
                    <Modal.Button
                        className="text-xs text-[#fff] cursor-pointer text-center my-3 underline font-medium "
                        opens="whymint"
                    >
                        Why Mint ?
                    </Modal.Button>
                    <Modal.Window name="whymint">
                        <MintModal />
                    </Modal.Window>
                </Modal>
            </div>
        </>
    );
}

export default ClaimedCertificateBack;
